/*eslint-disable*/
import React from "react";
import { NavLink as NavLinkRRD, Link, withRouter } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { logout } from "../../actions/auth";
import { DOMAIN } from "../../utils/constant";
// reactstrap components
import {
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import IconLogout from "../Icon/Logout";
// import { FontAwesomeIcon } from '@fortawesome/fontawesome-pro'
// import "@fortawesome/fontawesome-pro/css/all.min.css";

class UserSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.pathname !== this.props.pathname) {
      this.setState({
        collapsed: true,
      });
    }
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  state = {
    collapseOpen: false,
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen,
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false,
    });
  };
  // creates the links that appear in the left menu / Sidebar
  createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/dash/user") {
        return (
          <NavItem key={key}>
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={this.closeCollapse}
              activeClassName={
                String(this.props.pathname).includes(prop.path) ? "active" : ""
              }
            >
              {typeof prop.icon === String ? (
                <i className={prop.icon} />
              ) : (
                <prop.icon className="text-center" />
              )}
              {prop.name}
            </NavLink>
          </NavItem>
        );
      } else {
        return null;
      }
    });
  };
  render() {
    const { bgColor, routes, logo, selectedUser } = this.props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link,
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank",
      };
    }
    return (
      <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
      >
        <Container fluid>
          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={this.toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          {logo ? (
            // <NavbarBrand className="pt-0" {...navbarBrandProps}>
            //   <img
            //     alt={logo.imgAlt}
            //     className="navbar-brand-img"
            //     src={logo.imgSrc}
            //   />
            // </NavbarBrand>
            <a class="pt-2 navbar-brand text-left pb-0" href={DOMAIN}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
              />
            </a>
          ) : null}
          {/* User */}

          <Collapse navbar isOpen={this.state.collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={this.toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Divider */}

            <div className="mt--4">
              <hr className="my-3" />
              <span
                style={{
                  fontSize: ".9375rem",
                  lineHeight: "1.5rem",
                  fontFamily: "Font Awesome 5 Pro",
                  fontWeight: "300",
                  color: "rgba(0, 0, 0, 0.5)",
                }}
              >
                {selectedUser
                  ? selectedUser.pseudonym
                    ? "Hi, " + selectedUser.pseudonym + "!"
                    : "Hi, 親愛的用戶!"
                  : "Hi, 親愛的用戶!"}
              </span>
              <hr className="my-3" />
            </div>

            {/* Navigation */}
            <Nav navbar>
              {this.createLinks(routes)}
              <NavItem>
                <NavLink
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.logout();
                  }}
                >
                  <IconLogout className="size-5 mx-2 opacity-75" />
                  退出登陸
                </NavLink>
              </NavItem>
            </Nav>

            {/* Heading */}
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    pathname: state.router.location.pathname,
    search: state.router.location.search,
    hash: state.router.location.hash,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserSidebar);

UserSidebar.defaultProps = {
  routes: [{}],
};

UserSidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};
